import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 0,
  class: "not-check"
};
var _hoisted_4 = {
  key: 1,
  class: "check-box"
};
var _hoisted_5 = {
  class: "num"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  class: "bg-box"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  class: "like-count"
};
var _hoisted_11 = {
  key: 2,
  class: "time-title"
};
var _hoisted_12 = {
  class: "desc-box"
};
var _hoisted_13 = {
  class: "desc-title"
};
var _hoisted_14 = ["title"];
var _hoisted_15 = {
  key: 0,
  class: "participate"
};
var _hoisted_16 = {
  class: "desc-time"
};
import { ref, watch, onMounted, onUnmounted } from 'vue';
import empty from '../widgets/empty';
import { getFileType } from './picture.js';
import { giveALike, setStuActivity } from '@/api/spaceInfo.js';
import { MessagePlugin } from 'tdesign-vue-next';
export default {
  __name: 'index',
  props: {
    isWhere: {
      type: String,
      default: 'lesson'
    },
    synthesis: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    visitorType: {
      // 0:游客 1:自己(自己访问自己空间仍为个人视角)  2:公开
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    useToHome: {
      // 用于首页
      type: Boolean,
      default: false
    }
  },
  emits: ['upload', 'detail'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var props = __props;
    var listData = ref([]);
    var isCheckModule = ref(false); // 隐藏、公开选择模式
    var spaceHideFlag = ref(); // 个人主页隐藏标记：0公开、1隐藏、默认为空：查询所有
    var checkList = ref([]); // 选择的列表
    // 点赞 or 取消点赞
    var changeLike = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var opType, dynamicContentType;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                opType = !val.isLike ? '1' : '0';
                dynamicContentType = props.isWhere === 'lesson' ? '2' : '0';
                giveALike(val.id, dynamicContentType, opType);
                val.isLike ? val.isLike = 0 : val.isLike = 1;
                val.likeCount = val.isLike ? val.likeCount - 1 : val.likeCount += 1;
                MessagePlugin.success('操作成功');
                // emit('upload')
              } catch (error) {
                MessagePlugin.error('操作失败');
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function changeLike(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 查看详情
    var handleDetail = function handleDetail(data) {
      emit('detail', data);
    };
    watch(function () {
      return props;
    }, function (val) {
      var visitorType = val.visitorType,
        synthesis = val.synthesis;
      // like()
      if (synthesis.length) {
        listData.value = synthesis;
      }
      if (visitorType !== 1) {
        spaceHideFlag.value = null;
        isCheckModule.value = false;
      }
    }, {
      deep: true,
      immediate: true
    });
    var disable = function disable(val) {
      if (spaceHideFlag.value == 1) {
        //1隐藏
        return val === 1 ? true : false;
      } else {
        //0公开
        return val === 0 ? true : false;
      }
    };
    var handleCheck = function handleCheck(val) {
      isCheckModule.value = true;
      spaceHideFlag.value = val;
      listData.value = listData.value.map(function (item) {
        if (val == 1) {
          //1隐藏
          item.flag = item.spaceHideFlag === 1 ? true : false;
        } else {
          //0公开
          item.flag = item.spaceHideFlag === 0 ? true : false;
        }
        return item;
      });
    };
    var handleClose = function handleClose() {
      isCheckModule.value = false;
      checkList.value = [];
    };
    var handleComfrim = function handleComfrim() {
      if (checkList.value.length === 0) return MessagePlugin.error('请选择需要操作的内容');
      setStuActivity({
        showOrHideOpt: spaceHideFlag.value,
        works: checkList.value
      }).then(function (res) {
        handleClose();
        MessagePlugin.success('操作成功');
        emit('upload');
      });
    };
    var handleChange = function handleChange(val) {
      var index = checkList.value.findIndex(function (item) {
        return item.workId === val.id;
      });
      if (index !== -1) return checkList.value.splice(index, 1);
      checkList.value.push({
        workId: val.id,
        tableName: val.tableName
      });
    };
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_checkbox = _resolveComponent("t-checkbox");
      return _openBlock(), _createElementBlock("div", null, [__props.synthesis.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.visitorType === 1 && !__props.useToHome ? (_openBlock(), _createElementBlock("div", _hoisted_2, [!isCheckModule.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_t_button, {
        variant: "text",
        theme: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return handleCheck(1);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("隐藏内容", -1)]));
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        variant: "text",
        theme: "primary",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return handleCheck(0);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("公开内容", -1)]));
        }),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", null, [_createTextVNode(" 已选择需要" + _toDisplayString(spaceHideFlag.value === 1 ? '隐藏' : '公开') + "的内容", 1), _createElementVNode("span", _hoisted_5, _toDisplayString(checkList.value.length), 1)]), _createElementVNode("div", null, [_createVNode(_component_t_button, {
        variant: "text",
        theme: "default",
        onClick: handleClose
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("取消", -1)]));
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        variant: "text",
        theme: "primary",
        onClick: handleComfrim
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode("确定", -1)]));
        }),
        _: 1
      })])]))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(['synthesis', __props.useToHome && 'synthesis-list'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.synthesis, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "synthesis-item",
          onClick: function onClick($event) {
            return handleDetail(item);
          }
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: _unref(getFileType)(item.fileTypeText) || item.fileUrl,
          alt: "",
          class: "bg-img"
        }, null, 8, _hoisted_8), !isCheckModule.value ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "like-box",
          onClick: _withModifiers(function ($event) {
            return changeLike(item);
          }, ["stop"])
        }, [_createVNode(_component_svg_icon, {
          name: item.isLike === 0 ? 'red-star' : 'un-star',
          size: 13
        }, null, 8, ["name"]), _createElementVNode("span", _hoisted_10, _toDisplayString(item.likeCount), 1)], 8, _hoisted_9)) : _createCommentVNode("", true), item.fileType === 4 || item.fileType === 16 ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 1,
          name: "icon-rongqi-copy",
          size: 40,
          class: "pause"
        })) : _createCommentVNode("", true), item.fileType === 4 ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.fileTime), 1)) : _createCommentVNode("", true), isCheckModule.value && __props.visitorType === 1 ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "check-box",
          onClick: _cache[2] || (_cache[2] = _withModifiers(function () {}, ["stop"]))
        }, [_createVNode(_component_t_checkbox, {
          modelValue: item.flag,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.flag = $event;
          },
          disabled: disable(item.spaceHideFlag),
          onChange: function onChange($event) {
            return handleChange(item);
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])])) : _createCommentVNode("", true), __props.visitorType === 1 ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(['tip', item.spaceHideFlag === 1 ? 'hide' : 'open'])
        }, _toDisplayString(item.spaceHideFlag === 1 ? '已隐藏' : '已公开'), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", {
          class: _normalizeClass(__props.isWhere === 'lesson' ? 'lesson-name' : 'act-name'),
          title: (item === null || item === void 0 ? void 0 : item.name) || item.subjectName
        }, _toDisplayString(item.name || item.subjectName), 11, _hoisted_14), __props.isWhere === 'lesson' ? (_openBlock(), _createElementBlock("span", _hoisted_15, "参与互动: " + _toDisplayString(item.interactionCount) + "次", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, _toDisplayString(item.submitTime || item.time), 1)])], 8, _hoisted_6);
      }), 128))], 2)])) : _createCommentVNode("", true), !__props.synthesis.length && !__props.loading ? (_openBlock(), _createBlock(_unref(empty), {
        key: 1,
        type: __props.isWhere === 'lesson' ? 2 : 0,
        "visitor-type": __props.visitorType
      }, null, 8, ["type", "visitor-type"])) : _createCommentVNode("", true)]);
    };
  }
};